export const getInputStyles = (
  isTyping: boolean,
  disabled: boolean = false
) => ({
  "& .MuiInputBase-root": {
    height: "66px",
    display: "flex",
    alignItems: "center",
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    lineHeight: "14px",
    fontWeight: 700,
    minHeight: "66px",
    marginTop: isTyping ? "0" : "-24px",
  },
  ".MuiFormHelperText-root": {
    color: disabled ? "info.main" : "error.main",
  },
});
